import {
    AMOUNTS_DUE_AT_LEASE_SIGNING,
    AMOUNTS_DUE_AT_SIGNING,
    AMOUNT_PAID_AT_LEASE_SIGNING,
    AMOUNT_PAID_IN_CASH,
    CAPITALIZED_COST_BREAKDOWN,
    CREDIT_CARD_DOWN_PAYMENT,
    FIRST_MONTHLY_PAYMENT,
    HOW_AMOUNTS_DUE_WILL_BE_PAID,
    LEASE_PAYMENT,
    MI,
    MO,
    NET_TRADE_IN_AMOUNT,
    OTHER_UPFRONT_COSTS,
    SURFACE_PROTECTION,
    TAXES_AND_FEES,
    TOTAL_ACCESSORIES,
    TOTAL_CAPITALIZED_COST_REDUCTION,
    // TOTAL_CAPITALIZED_COST_REDUCTIONS,
    // TOTAL_CREDIT_CARD_PAYMENT,
    TOTAL_PROTECTION_PLANS,
    TRADE_IN,
    VEHICLE_PRICING_DETAIL,
    VEHICLE_PURCHASE_DETAILS,
    CASH_DOWN_PAYMENT,
    TOTAL_DOWN_PAYMENT,
    PRIORCREDITORLEASEOWEDONTRADE
} from 'constants/pdsConstant'
import { getDisclosures } from './disclosures-util'
import { numberFormat, numberToCurrencyFormat } from 'utils/number-format-util'

const disclosures = getDisclosures()

const formatText = (text, documentFeeName) => {
    if (text === 'documentFee') {
        return documentFeeName || disclosures[text]?.name
    } else {
        return disclosures[text]?.name
    }
}

const createDetailsObject = (key, input, documentFee) => {
    const detailsObj = {}
    if (key === 'totalAXZPlanPricing') {
        detailsObj.desc = [disclosures[key]?.name]
        detailsObj.badge = [true]
        detailsObj.badgeContent = [disclosures[key].order]
        detailsObj.axzPlanPrice = true
        detailsObj.axzPrice = [numberToCurrencyFormat(input[key])]
    } else {
        detailsObj.desc = [formatText(key, documentFee), numberToCurrencyFormat(input[key])]
        detailsObj.badge = [true]
        detailsObj.badgeContent = [disclosures[key].order]
    }
    if (key === 'dealerSellingPrice') {
        detailsObj.mandatory = true
    }
    return detailsObj
}

export const formatAccordionDetails = (input, boldAccordionDetails = [], documentFee = '') => {
    if (!input) return []

    return Object.keys(disclosures).reduce((detailsArray, key) => {
        if (typeof input[key] !== 'object' && input.hasOwnProperty(key) && input[key]) {
            const detailsObj = createDetailsObject(key, input, documentFee)
            if (boldAccordionDetails.includes(key)) {
                detailsObj.bold = [true, true]
            }
            detailsArray.push(detailsObj)
        } else {
            formatAccordionDetails(input[key], boldAccordionDetails, documentFee)
        }
        return detailsArray
    }, [])
}

export const createAccordions = (accordions, response, boldAccordionDetails = []) => {
    return accordions.reduce(
        (
            filteredAccordions,
            { id, name, order = 0, totalSummaryField, delimiter = '', styles, includeAXZPlan = false }
        ) => {
            if (response?.data?.hasOwnProperty(id)) {
                const obj = { summary: {}, details: [], hideExpandIcon: false }
                obj.hideExpandIcon = response && typeof response.data[id] !== 'object'
                obj.summary.desc = [name]
                obj.summary.includeAXZPlan = includeAXZPlan
                obj.summary.styles = styles
                if (disclosures[id]?.order) {
                    obj.summary.badge = [true]
                    obj.summary.badgeContent = [disclosures[id]?.order]
                }

                let summaryValue = totalSummaryField ? response.data[id][totalSummaryField] : response.data[id]
                obj.summary.desc[1] = delimiter + numberToCurrencyFormat(summaryValue)

                if (!obj.hideExpandIcon) {
                    obj.details = [
                        ...formatAccordionDetails(
                            response.data[id],
                            boldAccordionDetails,
                            response?.data?.document?.name
                        )
                    ]
                }
                obj.order = order
                if (summaryValue) {
                    filteredAccordions.push(obj)
                }
            }
            return filteredAccordions
        },
        []
    )
}

export const createProtectionPlanAccordion = ({ insuranceWarranties, totalOfInsuranceWarranties }, order) => {
    const obj = { summary: {}, details: [] }
    obj.summary = {
        desc: [disclosures.insuranceWarranties.name, numberToCurrencyFormat(totalOfInsuranceWarranties)],
        badge: [true],
        badgeContent: [disclosures.insuranceWarranties.order]
    }
    let protectionPlanAccordionDetails = (insuranceWarranties || []).reduce(
        (accumulator, { provider = '', product = '', premium }) => {
            if (premium) {
                const obj = {}
                product = product.replace(/([A-Z])/g, ' $1').trim()
                const productName = product.charAt(0).toUpperCase() + product.slice(1) // for capitalize first letter of text
                const providerName = `${provider} ${productName}`
                obj.desc = [providerName, numberToCurrencyFormat(premium)]
                accumulator.push(obj)
            }
            return accumulator
        },
        []
    )

    if (totalOfInsuranceWarranties) {
        protectionPlanAccordionDetails.push({
            desc: [TOTAL_PROTECTION_PLANS, numberToCurrencyFormat(totalOfInsuranceWarranties)],
            bold: [true, true]
        })
    }

    obj.details = [...protectionPlanAccordionDetails]
    obj.order = order
    return obj
}

export const createDownPaymentAccordion = (
    { cashDownPayment = 0, creditCardDownPayment = 0, otherRebate = 0, otherRebateDesc = '' },
    order
) => {
    const obj = { summary: {}, details: [] }
    const totalDownPayment = cashDownPayment + creditCardDownPayment + otherRebate
    obj.summary = {
        desc: [disclosures.cashDownPayment.name, `-${numberToCurrencyFormat(totalDownPayment)}`],
        badge: [true],
        badgeContent: [disclosures.cashDownPayment.order]
    }

    if (cashDownPayment) {
        obj.details.push({
            desc: [CASH_DOWN_PAYMENT, `-${numberToCurrencyFormat(cashDownPayment)}`]
        })
    }
    if (creditCardDownPayment) {
        obj.details.push({
            desc: [CREDIT_CARD_DOWN_PAYMENT, `-${numberToCurrencyFormat(creditCardDownPayment)}`]
        })
    }
    if (otherRebate) {
        obj.details.push({
            desc: [otherRebateDesc, `-${numberToCurrencyFormat(otherRebate)}`]
        })
    }
    obj.details.push({
        desc: [TOTAL_DOWN_PAYMENT, `-${numberToCurrencyFormat(cashDownPayment + creditCardDownPayment + otherRebate)}`],
        bold: [true, true]
    })
    obj.order = order
    return obj
}

export const createPriorCreditOrLeaseOwedOnTrade = (tradeInVehicle, order) => {
    const obj = { summary: {}, details: [] }
    obj.summary = {
        desc: [PRIORCREDITORLEASEOWEDONTRADE, numberToCurrencyFormat(tradeInVehicle.priorCreditOrLeaseOwedOnTrade || 0)]
    }
    obj.order = order
    obj.hideExpandIcon = true
    return obj
}

export const createTradeInAccordion = (tradeInVehicle, order) => {
    const obj = { summary: {}, details: [] }
    obj.summary = {
        desc: [TRADE_IN, numberToCurrencyFormat(-+tradeInVehicle.netTradeInAllowance || 0)]
    }
    obj.details = [
        {
            desc: [disclosures.grossAllowance.name, numberToCurrencyFormat(tradeInVehicle.grossAllowance)],
            badge: [true],
            badgeContent: [disclosures.grossAllowance.order]
        },
        {
            desc: [disclosures.payoffOwed.name, numberToCurrencyFormat(tradeInVehicle.payoffOwed)],
            badge: [true],
            badgeContent: [disclosures.payoffOwed.order]
        },
        {
            desc: [disclosures.netTradeInAllowance.name, numberToCurrencyFormat(tradeInVehicle.netTradeInAllowance)],
            badge: [true],
            badgeContent: [disclosures.netTradeInAllowance.order],
            bold: [true, true]
        }
    ]
    obj.order = order
    return obj
}

export const createNonLeaseAccordions = (response) => {
    const boldAccordionDetails = [
        'totalMsrp',
        'totalCostOfAccessories',
        'vehicleSellingPrice',
        'dealerSellingPrice',
        'netTradeInAllowance',
        'priorCreditOrLeaseOwedOnTrade'
    ]
    let accordions = [
        {
            id: 'pdsDealerSellingPrice',
            name: VEHICLE_PURCHASE_DETAILS,
            order: 1,
            totalSummaryField: 'dealerSellingPrice',
            includeAXZPlan: response?.data?.pdsDealerSellingPrice?.employeePricingIndicator
        },
        {
            id: 'totalCostOfAccessories',
            name: TOTAL_ACCESSORIES,
            order: 2
        },
        {
            id: 'currentAvailableIncentives',
            name: disclosures.currentAvailableIncentives.name,
            order: 6,
            delimiter: '-'
        }
    ]

    accordions = createAccordions(accordions, response, boldAccordionDetails)

    if (response.data?.insuranceWarranties.totalOfInsuranceWarranties) {
        accordions.push(createProtectionPlanAccordion(response.data.insuranceWarranties, 3))
    }

    if (response.data?.cashDownPayment || response.data?.creditCardDownPayment) {
        accordions.push(createDownPaymentAccordion(response.data, 4))
    }
    if (response.data?.tradeInVehicle?.priorCreditOrLeaseOwedOnTrade) {
        accordions.push(createPriorCreditOrLeaseOwedOnTrade(response.data.tradeInVehicle, 7))
    }
    if (response.data?.tradeInVehicle?.grossAllowance || response.data?.tradeInVehicle?.payoffOwed) {
        accordions.push(createTradeInAccordion(response.data.tradeInVehicle, 8))
    }
    return accordions
}

export const createCapitalizedCostBreakdownAccordion = () => {
    return {
        summary: {
            desc: [CAPITALIZED_COST_BREAKDOWN],
            styles: {
                '.MuiAccordionSummary-content > .MuiTypography-root > .MuiTypography-root': {
                    fontSize: '18px'
                }
            }
        },
        hideExpandIcon: true
    }
}

export const createGrossCapCostAccordion = (response, boldAccordionDetails) => {
    return (
        response?.data?.grossCapCost && {
            summary: {
                desc: [disclosures.grossCapCost.name, numberToCurrencyFormat(response.data.grossCapCost)],
                badge: [true],
                badgeContent: [disclosures.grossCapCost.order]
            },
            details: [
                ...createAccordions(
                    [
                        {
                            id: 'pdsDealerSellingPrice',
                            name: VEHICLE_PRICING_DETAIL,
                            totalSummaryField: 'dealerSellingPrice',
                            order: 1,
                            includeAXZPlan: response?.data?.pdsDealerSellingPrice?.employeePricingIndicator
                        },
                        {
                            id: 'totalCostOfAccessories',
                            name: TOTAL_ACCESSORIES,
                            order: 2,
                            styles: {
                                '.MuiTypography-root': {
                                    fontWeight: '600 !important'
                                }
                            }
                        },
                        {
                            id: 'surfaceProtection',
                            name: SURFACE_PROTECTION,
                            order: 3,
                            styles: {
                                '.MuiTypography-root': {
                                    fontWeight: '600 !important'
                                }
                            }
                        },
                        {
                            id: 'taxesAndFees',
                            name: TAXES_AND_FEES,
                            totalSummaryField: 'totalTaxesAndFees',
                            order: 5
                        },
                        {
                            id: 'grossCapCost',
                            name: disclosures.grossCapCost.name,
                            order: 7
                        }
                    ],
                    response,
                    boldAccordionDetails
                ),
                response.data?.tradeInVehicle?.priorCreditOrLeaseOwedOnTrade &&
                    createPriorCreditOrLeaseOwedOnTrade(response.data.tradeInVehicle, 6),
                (response.data?.tradeInVehicle?.grossAllowance || response.data?.tradeInVehicle?.payoffOwed) &&
                    response.data?.tradeInVehicle?.netTradeInAllowance < 0 &&
                    createTradeInAccordion(response.data?.tradeInVehicle, 8),
                response?.data?.insuranceWarranties?.totalOfInsuranceWarranties &&
                    createProtectionPlanAccordion(response.data.insuranceWarranties, 4)
            ]
                .filter((item) => item)
                .sort((a, b) => a.order - b.order)
        }
    )
}

export const createCapitalizedCostReductionAccordion = (response) => {
    return {
        summary: {
            desc: [
                disclosures.totalCapitalizedCostReduction.name,
                numberToCurrencyFormat(-+response.data.capitalizedCostReduction.totalCapitalizedCostReduction || -0)
            ],
            badge: [true],
            badgeContent: [disclosures.totalCapitalizedCostReduction.order]
        },
        // details: [
        //     response?.data?.capitalizedCostReduction?.downPayment && {
        //         desc: [
        //             disclosures.cashDownPayment.name,
        //             numberToCurrencyFormat(-+response.data.capitalizedCostReduction.downPayment || 0)
        //         ],
        //         badge: [true],
        //         badgeContent: [disclosures.cashDownPayment.order]
        //     },
        //     response?.data?.capitalizedCostReduction?.totalCreditCardPayment && {
        //         desc: [
        //             TOTAL_CREDIT_CARD_PAYMENT,
        //             numberToCurrencyFormat(-+response.data.capitalizedCostReduction.totalCreditCardPayment || 0)
        //         ]
        //     },
        //     response?.data?.capitalizedCostReduction?.currentAvailableIncentives && {
        //         desc: [
        //             disclosures.currentAvailableIncentives.name,
        //             numberToCurrencyFormat(-+response.data.capitalizedCostReduction.currentAvailableIncentives || 0)
        //         ],
        //         badge: [true],
        //         badgeContent: [disclosures.currentAvailableIncentives.order]
        //     },
        //     (response.data?.tradeInVehicle?.grossAllowance || response.data?.tradeInVehicle?.payoffOwed) &&
        //         response.data?.tradeInVehicle?.netTradeInAllowance >= 0 &&
        //         createTradeInAccordion(response.data?.tradeInVehicle),
        //     response?.data?.capitalizedCostReduction?.totalCapitalizedCostReduction && {
        //         desc: [
        //             TOTAL_CAPITALIZED_COST_REDUCTIONS,
        //             numberToCurrencyFormat(
        //                 -+response.data.capitalizedCostReduction.totalCapitalizedCostReduction || 0
        //             )
        //         ],
        //         badge: [true],
        //         badgeContent: [disclosures.totalCapitalizedCostReduction.order],
        //         bold: [true, true]
        //     }
        // ].filter((item) => item),
        hideExpandIcon: true
    }
}

export const createAdjustedCapCostAccordions = (response, boldAccordionDetails) => {
    return createAccordions(
        [
            {
                id: 'adjustedCapCost',
                name: disclosures.adjustedCapCost.name,
                styles: {
                    borderTop: (theme) => `1.5px solid ${theme.palette.text.primary}`,
                    borderBottom: (theme) => `1.5px solid ${theme.palette.text.primary}`
                }
            }
        ],
        response,
        boldAccordionDetails
    )
}

export const createLeasePaymentAccordion = (response) => {
    return (
        response?.data?.vehicleFinancing?.monthlyPayment && {
            summary: {
                desc: [LEASE_PAYMENT, numberToCurrencyFormat(response?.data?.vehicleFinancing?.monthlyPayment)]
            },
            details: [
                response?.data?.vehicleFinancing?.annualMileage && {
                    desc: [
                        disclosures.annualMileage.name,
                        `${numberFormat(response?.data?.vehicleFinancing.annualMileage)} ${MI}`
                    ],
                    badge: [true],
                    badgeContent: [disclosures.annualMileage.order]
                },
                response?.data?.vehicleFinancing?.term && {
                    desc: [disclosures.term.name, `${numberFormat(response?.data?.vehicleFinancing.term)} ${MO}`],
                    badge: [true],
                    badgeContent: [disclosures.term.order]
                },
                response?.data?.vehicleFinancing?.residualAmount && {
                    desc: [
                        disclosures.residualAmount.name,
                        numberToCurrencyFormat(response?.data?.vehicleFinancing.residualAmount)
                    ],
                    badge: [true],
                    badgeContent: [disclosures.residualAmount.order]
                },
                response?.data?.vehicleFinancing?.basePayment && {
                    desc: [
                        disclosures.basePayment.name,
                        numberToCurrencyFormat(response?.data?.vehicleFinancing.basePayment)
                    ],
                    badge: [true],
                    badgeContent: [disclosures.basePayment.order]
                },
                response?.data?.vehicleFinancing?.monthlyTax && {
                    desc: [
                        disclosures.monthlyTax.name,
                        numberToCurrencyFormat(response?.data?.vehicleFinancing.monthlyTax)
                    ],
                    badge: [true],
                    badgeContent: [disclosures.monthlyTax.order]
                },
                // For now Local Fee hided based on the Melissa report
                // response?.data?.vehicleFinancing?.monthlyLocalFee && {
                //     desc: [MONTHLYLOCALFEE, numberToCurrencyFormat(response?.data?.vehicleFinancing?.monthlyLocalFee)],
                //     badge: [false],
                //     badgeContent: [false]
                // },
                response?.data?.vehicleFinancing?.monthlyPayment && {
                    desc: [
                        disclosures.monthlyPayment.name,
                        numberToCurrencyFormat(response?.data?.vehicleFinancing.monthlyPayment)
                    ],
                    bold: [true, true],
                    badge: [true],
                    badgeContent: [disclosures.monthlyPayment.order]
                }
            ].filter((item) => item)
        }
    )
}

export const createLeaseAccordions = (response) => {
    const boldAccordionDetails = [
        'totalMsrp',
        'totalCostOfAccessories',
        'vehicleSellingPrice',
        'dealerSellingPrice',
        'netTradeInAllowance',
        'totalTaxesAndFees',
        'priorCreditOrLeaseOwedOnTrade'
    ]
    const accordions = [
        createCapitalizedCostBreakdownAccordion(),
        createGrossCapCostAccordion(response, boldAccordionDetails),
        createCapitalizedCostReductionAccordion(response),
        ...createAdjustedCapCostAccordions(response, boldAccordionDetails),
        createLeasePaymentAccordion(response)
    ].filter((item) => item)
    return accordions
}

export const createTotalAmountsDueAtLeaseSigningAccordion = (dueAtSigning) => {
    return (
        dueAtSigning.totalAmountsDueAtLeaseSigningOrDelivery && {
            summary: {
                desc: [AMOUNTS_DUE_AT_SIGNING]
            },
            details: [
                dueAtSigning.monthlyPayment && {
                    desc: [FIRST_MONTHLY_PAYMENT, numberToCurrencyFormat(dueAtSigning.monthlyPayment)]
                },
                dueAtSigning.capCostReduction && {
                    desc: [TOTAL_CAPITALIZED_COST_REDUCTION, numberToCurrencyFormat(dueAtSigning.capCostReduction)],
                    badge: [true],
                    badgeContent: [disclosures.totalCapitalizedCostReduction.order]
                },
                dueAtSigning.otherUpfrontCosts && {
                    desc: [OTHER_UPFRONT_COSTS, numberToCurrencyFormat(dueAtSigning.otherUpfrontCosts)]
                },
                dueAtSigning.totalAmountsDueAtLeaseSigningOrDelivery && {
                    desc: [
                        AMOUNTS_DUE_AT_LEASE_SIGNING,
                        numberToCurrencyFormat(dueAtSigning.totalAmountsDueAtLeaseSigningOrDelivery)
                    ],
                    bold: [true, true],
                    badge: [true, false],
                    badgeContent: [disclosures.totalAmountsDueAtLeaseSigningOrDelivery.order]
                }
            ].filter((item) => item),
            darkBackground: true,
            hideExpandIcon: true,
            defaultExpanded: true
        }
    )
}

export const createTotalAmountsDueAtLeaseSigning = (dueAtSigning) => {
    return (
        dueAtSigning.totalAmountsDueAtLeaseSigning && {
            summary: {
                desc: [HOW_AMOUNTS_DUE_WILL_BE_PAID]
            },
            details: [
                dueAtSigning.totalRebates && {
                    desc: [
                        disclosures.currentAvailableIncentives.name,
                        numberToCurrencyFormat(dueAtSigning.totalRebates)
                    ],
                    badge: [true],
                    badgeContent: [disclosures.currentAvailableIncentives.order]
                },
                dueAtSigning.netTradeInAllowance && {
                    desc: [NET_TRADE_IN_AMOUNT, numberToCurrencyFormat(dueAtSigning.netTradeInAllowance)],
                    badge: [true],
                    badgeContent: [disclosures.netTradeInAllowance.order]
                },
                dueAtSigning.amountsPaidInCash && {
                    desc: [AMOUNT_PAID_IN_CASH, numberToCurrencyFormat(dueAtSigning.amountsPaidInCash)]
                }
            ].filter((item) => item),
            footer: {
                desc: [
                    AMOUNT_PAID_AT_LEASE_SIGNING,
                    numberToCurrencyFormat(dueAtSigning.totalAmountsDueAtLeaseSigning)
                ],
                badge: [true],
                badgeContent: [disclosures.totalAmountsDueAtLeaseSigningOrDelivery.order]
            },
            darkBackground: true,
            hideExpandIcon: true,
            defaultExpanded: true
        }
    )
}

export const createDueAtSigningAccordions = (dueAtSigning) => {
    return [
        createTotalAmountsDueAtLeaseSigningAccordion(dueAtSigning),
        createTotalAmountsDueAtLeaseSigning(dueAtSigning)
    ].filter((item) => item)
}
